import { Button, Skeleton } from 'antd';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { InputText } from '../../../Assets/Components/CInput';
import CModalRFF from '../../../Assets/Components/CModalRFF';
import { InputRichText } from '../../../Assets/Components/CRichText';
import { Field } from 'react-final-form';
import CIcon from '../../../Assets/Components/CIcon';
import validate from '../Validation/AgreementContentValidation';

interface IProps {
  isShow: boolean;
  initialValues: any;
  modalAction: string;
  intl: any;
  editMode: boolean;
  disabled: boolean;
  isLoading: any;
  handleCancel: () => void;
  handleSubmit: (values: any) => void;
}

function ModalAgreementContentComponent(props: IProps) {
  const {
    isShow,
    initialValues,
    modalAction,
    intl,
    editMode,
    disabled,
    isLoading,
    handleCancel,
    handleSubmit,
  } = props;

  const headerComponent = () => {
    return (
      <h3 className="headerTitle capital">
        {modalAction === 'update' ? (
          <FormattedMessage id="detailAgreementContent" />
        ) : (
          <FormattedMessage id="addAgreementContent" />
        )}
      </h3>
    );
  };

  const contentComponent = (formProps: any) => {
    return (
      <>
        <Skeleton active loading={isLoading}>
          <Field
            name="name"
            component={InputText}
            idComponent="inputAgreementName"
            placeholder={intl.formatMessage({
              id: 'placeholderAgreementName',
            })}
            label={intl.formatMessage({ id: 'agreementName' })}
            editMode={editMode}
            disabled={disabled}
          />
          <Field
            name="desc"
            component={InputRichText}
            idComponent="inputAgreementContent"
            label={intl.formatMessage({ id: 'agreementContent' })}
            editMode={editMode}
            disabled={disabled}
          />
        </Skeleton>
      </>
    );
  };
  const buttonContent = (action: string, editMode: boolean) => {
    if (editMode === false) {
      if (action === 'register') {
        return 'Create';
      }
      return 'Edit';
    }
    return 'Save Change';
  };
  const footerComponent = (propsFooter: any) => {
    const { invalid } = propsFooter;
    return (
      <Button
        loading={isLoading}
        className={
          editMode ? (invalid ? 'btnSubmitDisabled' : 'btnSubmit') : 'btnSubmit'
        }
        icon={<CIcon type="CheckOutlined" />}
        disabled={modalAction === 'update' && !editMode ? false : invalid}
        id="btnSubmit"
        htmlType="submit"
      >
        {buttonContent(modalAction, editMode)}
      </Button>
    );
  };
  return (
    <CModalRFF
      modalIsShow={isShow}
      headerComponent={headerComponent()}
      contentComponent={(formProps: any) => contentComponent(formProps)}
      footerComponent={(formProps: any) => footerComponent(formProps)}
      handleCancel={handleCancel}
      handleValidation={validate}
      isForm={true}
      handleSubmit={handleSubmit}
      formLayout="horizontal"
      initialValues={initialValues}
    />
  );
}
export default injectIntl(ModalAgreementContentComponent);
